import React from 'react'
import { useShallow } from 'zustand/react/shallow'

import { getFileUrl, getImageSrcSet, getImageUrl } from '../helpers/utils'
import { useNavigationStore } from '../state/navigationStore'
import { I_CasePost } from '../state/wpDataStore'
import { CaseAttributes } from './CaseAttributes'

const CaseCard = ({ casePost }: { casePost: I_CasePost }) => {
  const { id, title, excerpt, acf } = casePost

  const { featured_images, attachment } = acf || {}

  const { setCaseModalOpen, setSelectedCasePostId } = useNavigationStore(
    useShallow((state) => ({
      setCaseModalOpen: state.setCaseModalOpen,
      setSelectedCasePostId: state.setSelectedCasePostId,
    }))
  )

  const onOpenModalClick = () => {
    setSelectedCasePostId(id)
    setCaseModalOpen(true)
  }

  const firstFeaturedImage = () => {
    if (featured_images && featured_images.length > 0) {
      const firstImage = featured_images[0].image
      const src = getImageUrl(firstImage, 'large') ?? getImageUrl(firstImage)
      if (!src) return null

      const srcSet = getImageSrcSet(firstImage)
      const sizes = '(min-width: 1024px) 800px, 100vw'

      return (
        <div className='case-card__image' onClick={onOpenModalClick}>
          <img src={src} srcSet={srcSet} sizes={srcSet ? sizes : undefined} />
        </div>
      )
    } else {
      return null
    }
  }

  return (
    <div className='case-card'>
      {firstFeaturedImage()}

      <div className='case-card__content'>
        <h4 className='case-card__title' onClick={onOpenModalClick}>
          {title?.rendered || `#${id}`}
        </h4>

        {excerpt && excerpt.rendered && (
          <div
            className='case-card__excerpt'
            dangerouslySetInnerHTML={{ __html: excerpt.rendered }}
          />
        )}

        {/* Attributes */}
        <CaseAttributes casePost={casePost} />

        <div className='case-card__meta'>
          {attachment && (
            <a href={getFileUrl(attachment)} download rel='noopener'>
              <i className='fa-solid fa-arrow-down-to-line'></i>
              <span>Download</span>
            </a>
          )}

          <a
            href='#'
            onClick={(e) => {
              e.preventDefault()
              onOpenModalClick()
            }}
          >
            <span>Read more</span>
          </a>
        </div>
      </div>
    </div>
  )
}

export { CaseCard }
